import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { CheckCircle2, Loader2, AlertTriangle } from "lucide-react";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [plan, setPlan] = useState(null);
  const { refreshUser } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          setPlan(data.plan);
          await refreshUser();
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
      } catch (e) {
        setStatus("error"); return;
      }
      if (attempts < 6) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#F7F8F6] grid place-items-center p-6">
      <div className="bg-white rounded-3xl border border-[#E2E5E0] p-10 max-w-md text-center shadow-sm" data-testid="billing-success">
        {status === "polling" && (
          <>
            <Loader2 className="w-12 h-12 text-[#1A4D2E] animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-medium" style={{ fontFamily: "Outfit" }}>Vérification du paiement…</h2>
            <p className="text-sm text-[#6B726A] mt-2">Cela ne prend que quelques secondes.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-[#E8F0EA] grid place-items-center mx-auto mb-4">
              <CheckCircle2 className="w-8 h-8 text-[#1A4D2E]" />
            </div>
            <h2 className="text-2xl font-medium" style={{ fontFamily: "Outfit" }}>Bienvenue en plan {plan} !</h2>
            <p className="text-sm text-[#6B726A] mt-2 mb-6">
              Votre abonnement est actif. Toutes les fonctionnalités sont débloquées.
            </p>
            <button onClick={() => nav("/dashboard")} data-testid="go-dashboard" className="rp-btn-primary">
              Accéder au tableau de bord
            </button>
          </>
        )}
        {(status === "error" || status === "expired" || status === "timeout") && (
          <>
            <div className="w-16 h-16 rounded-full bg-[#FFF4F3] grid place-items-center mx-auto mb-4">
              <AlertTriangle className="w-8 h-8 text-[#E3655B]" />
            </div>
            <h2 className="text-xl font-medium" style={{ fontFamily: "Outfit" }}>Paiement non finalisé</h2>
            <p className="text-sm text-[#6B726A] mt-2 mb-6">
              {status === "expired" ? "La session a expiré." : status === "timeout" ? "Le délai a été dépassé." : "Une erreur est survenue."} Réessayez ou contactez le support.
            </p>
            <button onClick={() => nav("/pricing")} className="rp-btn-primary">Retourner aux plans</button>
          </>
        )}
      </div>
    </div>
  );
}
